import HorizontalFlex from "layouts/flex/HorizontalFlex";
import style from "./MobileAddCartBase.module.css";
import FlexChild from "layouts/flex/FlexChild";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import P from "components/P";

function MobileAddCartBaseFooter({ buttonText, modalClose, onAddCartClick, onPurchaseClick, totalPrice }) {
    return (
        <div className={style.footer}>
            {/* 총액 표시 div 추가 */}
            <div 
                style={{ 
                    // height: "40px", 
                    width: "100%", 
                    display: "flex", 
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 20px",
                    borderTop: "1px solid #eee",
                    backgroundColor: "#F4F7FF"
                }}
            >
                <P weight={700} size={24}>총액 : </P>
                <P weight={700} color={"var(--main-color)"} size={24}>{totalPrice?.toLocaleString()} </P>
            </div>
            <HorizontalFlex gap={0} height={"max-content"}>
                <FlexChild>
                    <PaddingWrapper padding={"0px 0px"}>
                        <ButtonEclipse
                            text={"장바구니"}
                            fontSize={22}
                            onClick={onAddCartClick}
                            height={45}
                            borderRadius={0}
                            backgroundColor={"white"}
                            fontWeight={"bold"}
                            color={"var(--main-color)"}
                            border={null}
                        />
                    </PaddingWrapper>
                </FlexChild>
                <FlexChild>
                    <PaddingWrapper padding={"0px 0px"}>
                        <ButtonEclipse
                            text={"바로 구매하기"}
                            fontSize={22}
                            onClick={onPurchaseClick}
                            height={45}
                            borderRadius={0}
                            backgroundColor={"var(--main-color)"}
                            fontWeight={"bold"}
                            border={"2px solid var(--main-color)"}
                        />
                    </PaddingWrapper>
                </FlexChild>
            </HorizontalFlex>
        </div>
    );
}

export default MobileAddCartBaseFooter;